export const ROUTE = {
  LOGIN: '/',

  // region Private
  PRIVATE: 'p',
  ACCOUNT: 'profile',
  ACCOUNT_PASSWORD: 'password',
  STATISTIC: 'statistic',
  // region user, BO, category, product
  USER: 'user',
  USER_CREATE: 'create',
  USER_DETAIL: `:userId`,
  BUSINESS_OBJECT: 'business-object',
  BUSINESS_OBJECT_CREATE: 'create',
  BUSINESS_OBJECT_DETAIL: ':boId',
  CATEGORY: 'category',
  CATEGORY_CREATE: 'create',
  MASSIVE_CREATE: 'massive-create',
  CATEGORY_DETAIL: ':categoryId',
  PRODUCT: 'product',
  PRODUCT_CREATE: 'create',
  PRODUCT_DETAIL: ':productId',
  // endregion
  IMPORT_CUSTOMER_CSV: 'import-customer',
  CREDIT_PACKAGE_ORDER: 'credit-package-order',
  SYSTEM_WALLET: 'system-wallet',
  CREDIT_PACKAGE_MANAGEMENT: 'credit-package-management',
  SERVICE_TAG_MANAGEMENT: 'service-tag-management',
  SHORTENED_LINK: 'shortened-link',
  LEXOFFICE: 'lexoffice',
  INVOICE_JOB: 'invoice-job',
  FLYER_CAMPAIGN: 'flyer-campaign',
  // endregion
};
